var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPrivateMobility(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 32.371,
    height: 24.333,
    viewBox: "0 0 32.371 24.333",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_20744",
    "data-name": "Rectangle 20744",
    width: 32.371,
    height: 24.333,
    transform: "translate(0 0)",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_31957",
    "data-name": "Group 31957",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_31956",
    "data-name": "Group 31956",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_22507",
    "data-name": "Path 22507",
    d: "M16.188,24.333a3.07,3.07,0,1,1,3.069-3.07,3.073,3.073,0,0,1-3.069,3.07m0-4.14a1.07,1.07,0,1,0,1.069,1.07,1.071,1.071,0,0,0-1.069-1.07",
    fill: "#444"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22508",
    "data-name": "Path 22508",
    d: "M31,8.141A20.79,20.79,0,0,0,16.209,2h-.03A20.755,20.755,0,0,0,1.416,8.14L0,6.728A22.744,22.744,0,0,1,16.176,0h.033A22.737,22.737,0,0,1,32.371,6.683l-.663.751Z",
    fill: "#444"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22509",
    "data-name": "Path 22509",
    d: "M26.551,12.54a14.678,14.678,0,0,0-20.726,0L4.411,11.126a16.681,16.681,0,0,1,23.554,0Z",
    fill: "#444"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22510",
    "data-name": "Path 22510",
    d: "M21.932,17.171a8.142,8.142,0,0,0-11.488,0L9.032,15.755a10.146,10.146,0,0,1,14.312,0Z",
    fill: "#444"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrivateMobility);
export default __webpack_public_path__ + "static/media/private-mobility.65525393f889cb020e47e6bcde54af9c.svg";
export { ForwardRef as ReactComponent };